import { Component } from '@verndale/core';

import { breakpoints } from '../helpers/constants';

class UpCards extends Component {
  setupDefaults() {
    this.dom = {
      decorator: this.el.querySelector('.up-cards__decorator'),
      genericRow: this.el.querySelector('.generic-row'),
      cardsContainer: this.el.querySelector('.grid'),
      cards: this.el.querySelectorAll('.cta-description-card')
    };
  }

  addListeners() {
    const { cards } = this.dom;

    cards.forEach(card =>
      card.addEventListener('mouseover', this.onHoverCard.bind(this))
    );
    cards.forEach(card =>
      card.addEventListener('mouseleave', this.onLeaveCard.bind(this))
    );

    if (this.el.classList.contains('up-cards--dark') && this.dom.genericRow) {
      this.resizeDecorator();
      window.addEventListener('resize', this.resizeDecorator.bind(this));
    }
  }

  resizeDecorator() {
    const { offsetTop } = this.dom.cardsContainer;
    const { offsetHeight } = this.dom.cards[0].querySelector('img');

    this.dom.decorator.style.height = `${offsetTop + offsetHeight / 2}px`;
  }

  onHoverCard(e) {
    this.dom.cards.forEach(
      card => !card.contains(e.target) && card.classList.add('light-opacity')
    );
  }

  onLeaveCard(e) {
    this.dom.cards.forEach(
      card => !card.contains(e.target) && card.classList.remove('light-opacity')
    );
  }
}

export default UpCards;
